import { supabase } from "../../supabaseClient"

export const getAllCourseVideos = async (courseId) => {
    return await supabase
        .from('CourseVideo')
        .select("*")
        .eq('course_id', courseId)
}